import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  EmailShareButton,
} from 'react-share'

import { Button } from '@tribeplatform/react-ui-kit/Button'

export const SocialShareButtons = ({ url, title }) => {
  return (
    <div className="flex space-x-3">
      <FacebookShareButton className="flex-1" url={url} title={title}>
        <Button as="div" variant="outline" fullWidth>
          <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.8 1.66663C6.19751 1.66663 2.46667 5.39746 2.46667 9.99996C2.46667 14.1591 5.51417 17.6066 9.49834 18.2325V12.4083H7.38167V9.99996H9.49834V8.16413C9.49834 6.07579 10.7417 4.92246 12.6458 4.92246C13.5575 4.92246 14.5108 5.08496 14.5108 5.08496V7.13496H13.4608C12.425 7.13496 12.1025 7.77746 12.1025 8.43663V9.99996H14.4133L14.0442 12.4083H12.1025V18.2325C16.0858 17.6075 19.1333 14.1583 19.1333 9.99996C19.1333 5.39746 15.4025 1.66663 10.8 1.66663Z"
              fill="#2563EB"
            />
          </svg>
        </Button>
      </FacebookShareButton>
      <TwitterShareButton className="flex-1" url={url} title={title}>
        <Button as="div" variant="outline" fullWidth>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.4684 4.71315C17.8322 4.99456 17.1575 5.17938 16.4667 5.26148C17.1948 4.82601 17.7398 4.14066 18 3.33315C17.3167 3.73982 16.5675 4.02482 15.7867 4.17898C15.2622 3.6178 14.567 3.24562 13.8092 3.1203C13.0513 2.99499 12.2733 3.12356 11.5961 3.48603C10.9189 3.8485 10.3804 4.42455 10.0643 5.12464C9.74824 5.82473 9.67233 6.60963 9.84838 7.35732C8.46263 7.28786 7.10699 6.92775 5.86945 6.30037C4.63191 5.67299 3.54015 4.79236 2.66504 3.71565C2.35529 4.24769 2.19251 4.85251 2.19338 5.46815C2.19338 6.67648 2.80838 7.74398 3.74338 8.36898C3.19005 8.35156 2.6489 8.20213 2.16504 7.93315V7.97648C2.16521 8.78123 2.44368 9.56116 2.95325 10.184C3.46282 10.8069 4.17211 11.2344 4.96088 11.394C4.44722 11.5332 3.90863 11.5537 3.38588 11.454C3.60827 12.1467 4.04172 12.7525 4.62554 13.1866C5.20936 13.6207 5.91432 13.8613 6.64171 13.8748C5.91878 14.4426 5.09102 14.8623 4.20578 15.11C3.32053 15.3576 2.39515 15.4284 1.48254 15.3182C3.07563 16.3427 4.93012 16.8866 6.82421 16.8848C13.235 16.8848 16.7409 11.574 16.7409 6.96815C16.7409 6.81815 16.7367 6.66648 16.73 6.51815C17.4124 6.02496 18.0014 5.414 18.4692 4.71398L18.4684 4.71315Z"
              fill="#60A5FA"
            />
          </svg>
        </Button>
      </TwitterShareButton>
      <LinkedinShareButton className="flex-1" url={url} title={title}>
        <Button as="div" variant="outline" fullWidth>
          <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.4791 15.2825H13.2583V11.8017C13.2583 10.9717 13.2416 9.90333 12.1 9.90333C10.9425 9.90333 10.7658 10.8067 10.7658 11.7408V15.2825H8.54412V8.125H10.6775V9.1H10.7066C11.005 8.53833 11.73 7.94417 12.8133 7.94417C15.0633 7.94417 15.48 9.42583 15.48 11.3533V15.2825H15.4791ZM6.03578 7.14583C5.86625 7.14605 5.69833 7.11281 5.54167 7.04801C5.38501 6.9832 5.24267 6.88812 5.12283 6.7682C5.00299 6.64828 4.90799 6.50588 4.84329 6.34918C4.77859 6.19247 4.74546 6.02454 4.74578 5.855C4.74595 5.59986 4.82177 5.3505 4.96365 5.13846C5.10554 4.92641 5.30711 4.76119 5.54289 4.66371C5.77867 4.56623 6.03806 4.54085 6.28827 4.59078C6.53847 4.64072 6.76825 4.76373 6.94854 4.94426C7.12883 5.12478 7.25155 5.35472 7.30116 5.60498C7.35077 5.85525 7.32506 6.11461 7.22727 6.35026C7.12948 6.58592 6.96401 6.78728 6.75178 6.92889C6.53955 7.0705 6.29009 7.146 6.03495 7.14583H6.03578ZM7.14912 15.2825H4.92162V8.125H7.14995V15.2825H7.14912ZM16.5916 2.5H3.80745C3.19412 2.5 2.69995 2.98333 2.69995 3.58083V16.4192C2.69995 17.0167 3.19495 17.5 3.80662 17.5H16.5883C17.2 17.5 17.7 17.0167 17.7 16.4192V3.58083C17.7 2.98333 17.2 2.5 16.5883 2.5H16.5908H16.5916Z"
              fill="#3B82F6"
            />
          </svg>
        </Button>
      </LinkedinShareButton>
      <WhatsappShareButton className="flex-1" url={url} title={title}>
        <Button as="div" variant="outline" fullWidth>
          <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.06999 18.3333L3.19666 14.1933C2.45428 12.9207 2.06424 11.4733 2.06666 9.99996C2.06666 5.39746 5.79749 1.66663 10.4 1.66663C15.0025 1.66663 18.7333 5.39746 18.7333 9.99996C18.7333 14.6025 15.0025 18.3333 10.4 18.3333C8.92731 18.3357 7.48054 17.9459 6.20833 17.2041L2.06999 18.3333ZM7.39249 6.08996C7.28488 6.09664 7.17972 6.12499 7.08333 6.17329C6.99293 6.22448 6.91041 6.28848 6.83833 6.36329C6.73833 6.45746 6.68166 6.53913 6.62083 6.61829C6.31284 7.01912 6.14717 7.51114 6.14999 8.01663C6.15166 8.42496 6.25833 8.82246 6.42499 9.19413C6.76583 9.94579 7.32666 10.7416 8.06749 11.4791C8.24583 11.6566 8.41999 11.835 8.60749 12.0008C9.52699 12.8103 10.6227 13.3942 11.8075 13.7058L12.2817 13.7783C12.4358 13.7866 12.59 13.775 12.745 13.7675C12.9877 13.7549 13.2247 13.6892 13.4392 13.575C13.5775 13.5016 13.6425 13.465 13.7583 13.3916C13.7583 13.3916 13.7942 13.3683 13.8625 13.3166C13.975 13.2333 14.0442 13.1741 14.1375 13.0766C14.2067 13.005 14.2667 12.9208 14.3125 12.825C14.3775 12.6891 14.4425 12.43 14.4692 12.2141C14.4892 12.0491 14.4833 11.9591 14.4808 11.9033C14.4775 11.8141 14.4033 11.7216 14.3225 11.6825L13.8375 11.465C13.8375 11.465 13.1125 11.1491 12.67 10.9475C12.6233 10.9271 12.5733 10.9155 12.5225 10.9133C12.4655 10.9074 12.4079 10.9139 12.3535 10.9321C12.2992 10.9504 12.2494 10.98 12.2075 11.0191V11.0175C12.2033 11.0175 12.1475 11.065 11.545 11.795C11.5104 11.8414 11.4628 11.8765 11.4082 11.8958C11.3535 11.9151 11.2944 11.9177 11.2383 11.9033C11.184 11.8888 11.1308 11.8704 11.0792 11.8483C10.9758 11.805 10.94 11.7883 10.8692 11.7575L10.865 11.7558C10.3883 11.5476 9.94685 11.2665 9.55666 10.9225C9.45166 10.8308 9.35416 10.7308 9.25416 10.6341C8.92631 10.3202 8.64059 9.96497 8.40416 9.57746L8.35499 9.49829C8.31968 9.4451 8.29113 9.38771 8.26999 9.32746C8.23833 9.20496 8.32083 9.10663 8.32083 9.10663C8.32083 9.10663 8.52333 8.88496 8.61749 8.76496C8.6959 8.66523 8.76906 8.56148 8.83666 8.45413C8.93499 8.29579 8.96583 8.13329 8.91416 8.00746C8.68083 7.43746 8.43916 6.86996 8.19083 6.30663C8.14166 6.19496 7.99583 6.11496 7.86333 6.09913C7.81833 6.09413 7.77333 6.08913 7.72833 6.08579C7.61642 6.08023 7.50427 6.08135 7.39249 6.08913V6.08996Z"
              fill="#10B981"
            />
          </svg>
        </Button>
      </WhatsappShareButton>
      <EmailShareButton className="flex-1" url={url} title={title}>
        <Button as="div" variant="outline" fullWidth>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.00288 5.884L9.99988 9.882L17.9969 5.884C17.9673 5.37444 17.744 4.89549 17.3727 4.54523C17.0014 4.19497 16.5103 3.99991 15.9999 4H3.99988C3.48946 3.99991 2.99832 4.19497 2.62706 4.54523C2.25579 4.89549 2.03248 5.37444 2.00288 5.884Z"
              fill="#9CA3AF"
            />
            <path
              d="M17.9999 8.118L9.99988 12.118L1.99988 8.118V14C1.99988 14.5304 2.21059 15.0391 2.58566 15.4142C2.96074 15.7893 3.46944 16 3.99988 16H15.9999C16.5303 16 17.039 15.7893 17.4141 15.4142C17.7892 15.0391 17.9999 14.5304 17.9999 14V8.118Z"
              fill="#9CA3AF"
            />
          </svg>
        </Button>
      </EmailShareButton>
    </div>
  )
}
